import {
    mobile,
    backend,
    creator,
    web,
    javascript,
    typescript,
    html,
    css,
    reactjs,
    redux,
    tailwind,
    nodejs,
    mongodb,
    git,
    figma,
    docker,
    meta,
    starbucks,
    tesla,
    shopify,
    carrent,
    jobit,
    tripguide,
    threejs,
} from "../assets";
import TechInject from "../assets/experience/logo-dark.svg";
import LaMajesteGroup from "../assets/experience/laMajesteGroup.jpeg";
import Cysque from "../assets/experience/cysque_software_cover.jpeg";
import Hyualife from "../assets/experience/thehyugalife_logo.jpg";

export const navLinks = [
    // {
    //   id: "CV",
    //   title: "Download CV",
    //   url: "https://github.com/thatscoding/resume/blob/main/SACHIN%20SHAKYA.pdf",
    // },
    {
        id: "about",
        title: "About",
    },
    {
        id: "work",
        title: "Work",
    },
    {
        id: "contact",
        title: "Contact",
    },
];

const services = [
    {
        title: "Frontend Developer",
        icon: web,
    },
    {
        title: "React Developer",
        icon: mobile,
    },
    {
        title: "Backend Developer",
        icon: backend,
    },
    {
        title: "Full Stack Developer",
        icon: creator,
    },
];

const technologies = [
    {
        name: "HTML 5",
        icon: html,
    },
    {
        name: "CSS 3",
        icon: css,
    },
    {
        name: "JavaScript",
        icon: javascript,
    },
    {
        name: "TypeScript",
        icon: typescript,
    },
    {
        name: "React JS",
        icon: reactjs,
    },
    {
        name: "Redux Toolkit",
        icon: redux,
    },
    {
        name: "Tailwind CSS",
        icon: tailwind,
    },
    {
        name: "Node JS",
        icon: nodejs,
    },
    {
        name: "MongoDB",
        icon: mongodb,
    },
    {
        name: "Three JS",
        icon: threejs,
    },
    {
        name: "git",
        icon: git,
    },
    {
        name: "figma",
        icon: figma,
    },
    {
        name: "docker",
        icon: docker,
    },
];

const experiences = [
    {
        title: "Software Development Engineer",
        company_name: "Hyugalife",
        icon: Hyualife,
        iconBg: "#E6DEDD",
        date: "March 2025 - Present",
        points: [
            "Develop and maintain responsive and scalable web applications using React.js, Next.js, Redux Toolkit, Tailwind CSS, and Node.js.",
            "Collaborate with cross-functional teams including designers, backend developers, and product managers to translate business requirements into efficient technical solutions.",
            "Participate in code reviews to maintain high code quality, enforce best practices, and improve team efficiency.",
            "Work closely with UI/UX designers to implement intuitive and visually appealing user interfaces ensuring optimal user experience.",
            "Troubleshoot, debug, and optimize application performance across browsers and devices.",
            "Contribute to continuous improvement by staying updated with the latest frontend & backend technologies, frameworks, and industry best practices.",
        ],
    },
    {
        title: "Software Development Engineer",
        company_name: "Tech Inject LLP",
        icon: TechInject,
        iconBg: "#383E56",
        date: "January 2024 - March 2025",
        points: [
            "Designed, developed, and maintained robust full-stack applications using SvelteKit, ReactJS, Node.js, Firebase (Firestore & Functions), and MongoDB.",
            "Implemented and optimized 25+ CRUD operations across multiple modules to ensure smooth data handling and scalability.",
            "Developed and deployed Firebase Cloud Functions for serverless backend logic, improving performance and reducing infrastructure overhead.",
            "Took full ownership of one key product — from planning and architecture to deployment — successfully delivered and maintained post-launch.",
            "Collaborated with cross-functional teams to define requirements, troubleshoot issues, and deliver high-quality, production-ready software solutions.",
            "Worked closely with UI/UX designers to convert mockups into responsive, accessible, and visually engaging user interfaces.",
            "Participated in code reviews and implemented best practices to ensure clean, maintainable, and efficient code.",
            "Continuously explored emerging technologies and frameworks to enhance development processes and product quality.",
        ],
    },
    {
        title: "Full Stack Developer",
        company_name: "La Majeste Group",
        icon: LaMajesteGroup,
        iconBg: "#383E56",
        date: "August 2022 - December 2023",
        points: [
            "Developed and maintained dynamic and scalable full-stack web applications using ReactJS, Node.js, Express, and MongoDB.",
            "Built responsive, user-friendly interfaces and optimized front-end performance for better user experience.",
            "Integrated RESTful APIs and implemented secure authentication and authorization using JWT and Firebase.",
            "Collaborated with designers and backend teams to translate business requirements into functional features.",
            "Participated in agile development cycles, contributing to sprint planning, daily stand-ups, and retrospectives.",
            "Conducted code reviews and implemented best practices to maintain clean, efficient, and maintainable codebases.",
            "Debugged and resolved performance bottlenecks, ensuring smooth functionality and system stability.",
            "Actively learned emerging technologies and frameworks to improve development efficiency and product quality.",
        ],
    },
    // {
    //     title: "Software Engineer Intern",
    //     company_name: "Cysque Softwares",
    //     icon: Cysque,
    //     iconBg: "#E6DEDD",
    //     date: "Sept 2021 - Feb 2022",
    //     points: [
    //         "Completed 70 hours of training on MERN Stack development on Coursera .",
    //         "Enthusiastic front-end developer undergoing comprehensive training in HTML, CSS, JavaScript, and React.",
    //         "Collaborating with senior developers to learn and implement best practices in creating responsive and visually appealing user interfaces.",
    //         "Gaining hands-on experience in modern frontend frameworks and libraries, including React, to enhance web application development skills.",
    //         "Actively participating in code reviews, absorbing feedback, and contributing to team projects with a strong commitment to learning and growth.",
    //     ],
    // },
    // {
    //   title: "Web Developer",
    //   company_name: "Shopify",
    //   icon: shopify,
    //   iconBg: "#383E56",
    //   date: "Jan 2022 - Jan 2023",
    //   points: [
    //     "Developing and maintaining web applications using React.js and other related technologies.",
    //     "Collaborating with cross-functional teams including designers, product managers, and other developers to create high-quality products.",
    //     "Implementing responsive design and ensuring cross-browser compatibility.",
    //     "Participating in code reviews and providing constructive feedback to other developers.",
    //   ],
    // },
    // {
    //   title: "Full stack Developer",
    //   company_name: "Meta",
    //   icon: meta,
    //   iconBg: "#E6DEDD",
    //   date: "Jan 2023 - Present",
    //   points: [
    //     "Developing and maintaining web applications using React.js and other related technologies.",
    //     "Collaborating with cross-functional teams including designers, product managers, and other developers to create high-quality products.",
    //     "Implementing responsive design and ensuring cross-browser compatibility.",
    //     "Participating in code reviews and providing constructive feedback to other developers.",
    //   ],
    // },
];

const testimonials = [
    {
        testimonial:
            "I thought it was impossible to make a website as beautiful as our product, but Rick proved me wrong.",
        name: "Sara Lee",
        designation: "CFO",
        company: "Acme Co",
        image: "https://randomuser.me/api/portraits/women/4.jpg",
    },
    {
        testimonial:
            "I've never met a web developer who truly cares about their clients' success like Rick does.",
        name: "Chris Brown",
        designation: "COO",
        company: "DEF Corp",
        image: "https://randomuser.me/api/portraits/men/5.jpg",
    },
    {
        testimonial:
            "After Rick optimized our website, our traffic increased by 50%. We can't thank them enough!",
        name: "Lisa Wang",
        designation: "CTO",
        company: "456 Enterprises",
        image: "https://randomuser.me/api/portraits/women/6.jpg",
    },
];

const projects = [
    {
        name: "Partywitty Artist Module",
        description:
            "Developing an artist module for a party-witty application using the MERN (MongoDB, Express.js, React.js, Node.js) stack, enabling seamless artist profile creation, management, and booking. Integrated real-time communication features to facilitate artist-client interactions. Implemented a robust search and recommendation system for artists based on user preferences. Ensured secure payment processing and handled event scheduling, enhancing user experience and event planning efficiency. Employed agile development methodologies to deliver a dynamic and user-centric module..",
        tags: [
            {
                name: "ReactJs",
                color: "blue-text-gradient",
            },
            {
                name: "Redux",
                color: "blue-text-gradient",
            },
            {
                name: "Tailwind CSS",
                color: "green-text-gradient",
            },
            {
                name: "Rest API",
                color: "pink-text-gradient",
            },
            {
                name: "NodeJS",
                color: "blue-text-gradient",
            },
            {
                name: "ExpressJS",
                color: "green-text-gradient",
            },
            {
                name: "MongoDB",
                color: "pink-text-gradient",
            },
            {
                name: "Deployment",
                color: "blue-text-gradient",
            },
        ],
        image: carrent,
        source_code_link: "https://github.com/",
    },
    {
        name: "Erhem AI & Erhem Group & Erhem Mobile",
        description:
            "Maintained and developed  Erhem AI, Erhem Group MERN stack, and Erhem Mobile Native using React Native for mobile platforms. Leveraged MERN stack technologies to build robust and scalable web applications. Implemented cutting-edge AI features to enhance user experience and streamline processes. Delivered seamless cross-platform mobile applications with React Native, ensuring optimal performance and user satisfaction. Demonstrated expertise in full-stack development, API integration, and responsive design. Contributed to the success of Erhem projects by delivering high-quality, innovative solutions. Established a strong track record in developing versatile and impactful software solutions.",
        tags: [
            {
                name: "ReactJs",
                color: "blue-text-gradient",
            },
            {
                name: "NextJS",
                color: "blue-text-gradient",
            },
            {
                name: "Redux",
                color: "green-text-gradient",
            },
            {
                name: "TailWind CSS",
                color: "pink-text-gradient",
            },
            {
                name: "NodeJS",
                color: "blue-text-gradient",
            },
            {
                name: "ExpressJS",
                color: "green-text-gradient",
            },
            {
                name: "MongoDB",
                color: "pink-text-gradient",
            },
            {
                name: "Rest API",
                color: "blue-text-gradient",
            },
            {
                name: "Deployment",
                color: "green-text-gradient",
            },
        ],
        image: jobit,
        source_code_link: "https://github.com/",
    },
    {
        name: "EasySalon",
        description:
            "Worked as a Full Stack Developer in the EasySalon application, I played a pivotal role in the development of a cutting-edge web application that revolutionized the salon management industry. Leveraging my expertise in front-end technologies like React and back-end proficiency in Node.js and MongoDB, I engineered a responsive and user-friendly platform. I contributed to seamless appointment scheduling, payment processing, and inventory management, enhancing operational efficiency for salons and spas. My dedication to optimizing performance and ensuring scalability resulted in a high-performing application. Through collaboration with cross-functional teams, I delivered innovative solutions that enriched the user experience of both salon owners and clients.",
        tags: [
            {
                name: "ReactJs",
                color: "blue-text-gradient",
            },
            {
                name: "Redux",
                color: "blue-text-gradient",
            },
            {
                name: "Tailwind CSS",
                color: "green-text-gradient",
            },
            {
                name: "Rest API",
                color: "pink-text-gradient",
            },
            {
                name: "NodeJS",
                color: "blue-text-gradient",
            },
            {
                name: "ExpressJS",
                color: "green-text-gradient",
            },
            {
                name: "MongoDB",
                color: "pink-text-gradient",
            },
            {
                name: "Deployment",
                color: "blue-text-gradient",
            },
        ],
        image: tripguide,
        source_code_link: "https://github.com/",
    },
];

export { services, technologies, experiences, testimonials, projects };
